import {
  TablePage,
  AddPage,
  EditPage,
  ViewPage,
} from 'src/views/docgen/h2hsubfails'
import pathMap from 'src/paths/pathMap'

class H2hSubFailsRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.H2H_SUB_FAILS_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.H2H_SUB_FAILS_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.H2H_SUB_FAILS_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.H2H_SUB_FAILS_DETAILS_VIEW,
        component: ViewPage
      }
    ]
  }
}

export default H2hSubFailsRoute
